<ng-container *ngIf="patients">
    <app-patient-list 
        (onRowView)="onRowView( $event )" 
        (onPatientAdd)="onPatientAdd()"
        [hasButtonStatus]="true"
        [hasButtonAdd]="true"
        [patients]="patients"
        [statuses]="statuses">
    </app-patient-list>
</ng-container>